'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useAlertContext } from './AlertContext';
import { alertTheme } from './theme';
const AlertDismiss = forwardRef(({ children, onClick, className, ...props }, ref) => {
    const { link } = alertTheme;
    const { color = 'secondary' } = useAlertContext();
    return (_jsx("button", { ...props, onClick: onClick, ref: ref, className: cn(link.color[color], className), children: children ?? (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "currentColor", viewBox: "0 0 256 256", children: _jsx("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }) })) }));
});
AlertDismiss.displayName = 'AlertDismiss';
export { AlertDismiss };
